import React from 'react';
import { Document, Page, View, Image, Text } from '@react-pdf/renderer';
import styles from './PDFDocumentStyle';
import sublogo from "./assets/logo.png"

const convertInt2String = (num) => {
  const convertNum = num || 0;
  return String(convertNum).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
};

// TableHeader 컴포넌트
const Header = ({ userName, date, buildingName, room }) => {
  const firstRoomName = room.length > 0 ? room[0].roomName : "";
  const roomCount = room.length;

  return (
    <View style={styles.header}>
      <Text style={styles.headerTitle}>
        전기 및 수도 요금 청구서
      </Text>
      <Text style={styles.headerDate}>
        날짜: {date}
      </Text>
      <Text style={styles.headerUserName}>
        {userName}님 귀하
      </Text>
      <Text style={styles.headerUserName}>
        {buildingName} {roomCount >= 1 
          ? firstRoomName 
          : `${firstRoomName} 외 ${roomCount - 1}개 호실`}
      </Text>
    </View>
  )
};

const RoomInfoTableHeader = () => (
  <View style={styles.table}>
    <View style={styles.tableRow}>
      <View style={[styles.tableColHeader, {width: "25%"}]}>
        <Text>호실명</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "25%"}]}>
        <Text>임차사명</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "25%"}]}>
        <Text>전용면적</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "25%"}]}>
        <Text>임대비율</Text>
      </View>
    </View>
  </View>
);

const RoomInfoTableRow = ({ room }) => (
  <View style={styles.table}>
    {room.map((roomInfo, index) => (
      <View style={styles.tableRow}>
        <View style={[styles.tableColRow, styles.tableCenter, {width: "25%"}]}>
          <Text>{roomInfo.roomName}</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableCenter, {width: "25%"}]}>
          <Text>{roomInfo.roomCustomerName}</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableCenter, {width: "25%"}]}>
          <Text>{convertInt2String(roomInfo.roomPrivateArea)}㎡</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableCenter, {width: "25%"}]}>
          <Text>{(roomInfo.privateAreaRatio * 100).toFixed(1)}%</Text>
        </View>
      </View>
    ))}
  </View>
);

const ElecTableHeader = () => (
  <View style={styles.table}>
    <View style={styles.tableRow}>
      <View style={[styles.tableColHeader, {width: "15%"}]}>
        <Text>호실명</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>전기요금(VAT포함)</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>전력기금</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>TV요금</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>금액조정</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>청구금액</Text>
      </View>
    </View>
  </View>
)

const ElecTableRow = ({ room }) => (
  <View style={styles.table}>
    {room.map((roomInfo, index) => (
      <View style={styles.tableRow}>
        <View style={[styles.tableColRow, styles.tableCenter, {width: "15%"}]}>
          <Text>{roomInfo.roomName}</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.elecPrice + roomInfo.elecVAT)}원</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.elecFund)}원</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.elecTV)}원</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.roomElecChangePrice)}원</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.totalElecPrice)}원</Text>
        </View>
      </View>
    ))}
  </View>
)

const WaterTableHeader = () => (
  <View style={styles.table}>
    <View style={styles.tableRow}>
      <View style={[styles.tableColHeader, {width: "15%"}]}>
        <Text>호실명</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>수도 사용량</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>사용량에 따른 금액</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>공용수도금액</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>금액조정</Text>
      </View>
      <View style={[styles.tableColHeader, {width: "17%"}]}>
        <Text>청구금액</Text>
      </View>
    </View>
  </View>
)

const WaterTableRow = ({ room }) => (
  <View style={styles.table}>
    {room.map((roomInfo, index) => (
      <View style={styles.tableRow}>
        <View style={[styles.tableColRow, styles.tableCenter, {width: "15%"}]}>
          <Text>{roomInfo.roomName}</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableCenter, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.roomCurrWaterUsed - roomInfo.roomPrevWaterUsed)}</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.roomWaterPrice)}원</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.roomCommonWaterPrice)}원</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.roomWaterChangePrice)}원</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, {width: "17%"}]}>
          <Text>{convertInt2String(roomInfo.totalWaterPrice)}원</Text>
        </View>
      </View>
    ))}
  </View>
)

const TotalPrice = ({ room }) => {
  const totalSum = room.reduce((acc, curr) => acc + (curr.totalPrice || 0), 0);

  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <View style={[styles.tableColRow, styles.tableCenter, styles.tableTotalPrice, {width: "83%"}]}>
          <Text>최종 청구 금액</Text>
        </View>
        <View style={[styles.tableColRow, styles.tableRight, styles.tableTotalPrice, {width: "17%"}]}>
          <Text>{convertInt2String(totalSum)}원</Text>
        </View>
      </View>
    </View>
  )
}


const PDFDocument = ({ userName, date, buildingName, room }) => (

  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.pageView}>
        <Header userName={userName} date={date} buildingName={buildingName} room={Array.isArray(room) ? room : [room]}/>
        <View style={[styles.tableContainer, styles.tableRoomContainer]}>
          <RoomInfoTableHeader/>
          <RoomInfoTableRow room={Array.isArray(room) ? room : [room]} />
        </View>
        <View style={styles.tableContainer}>
          <ElecTableHeader/>
          <ElecTableRow room={Array.isArray(room) ? room : [room]} />
        </View>
        <View style={styles.tableContainer}>
          <WaterTableHeader/>
          <WaterTableRow room={Array.isArray(room) ? room : [room]} />
        </View>
        <View style={styles.tableContainer}>
          <TotalPrice room={Array.isArray(room) ? room : [room]}/>
        </View>
      </View>
      <View style={styles.footerContainer}>
        <View style={styles.footer}>
          <Image src={sublogo} style={styles.subLogo} alt="클리니어빌딩 subLogo" />
        </View>
      </View>
    </Page>
  </Document>
);

export default PDFDocument;
